/* eslint-disable react/jsx-key */
import React, { useState, useContext, useEffect } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { connect } from 'react-redux'
import moment from 'moment'
import R from 'ramda'
import CommonScreen from 'admin/component/CommonScreen'
import {
  getEnvConfig,
  getPermitActions,
  // hasAccesPermits,
  getApiTargetInfo,
} from 'core'
import { ErrorContext } from 'context'
// import * as ScreenPermissions from 'core/EventActions'
import {
  getSolarField,
  getSolarPlant,
  getSolarInverterGroup,
  getSolarStorageGroup,
  upsertFieldValue,
  getAllFieldValue,
  deleteSolarFieldValue,
} from 'api/pgads'
import { Button, DatePicker, Input, InputNumber, Select } from 'antd'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { DATE_TIME_FORMAT_API, DATE_FORMAT_API } from 'enum'
import { Label } from 'core/screen-util'
import { getValidPlantList, getValidStoragePlantList } from '../../solar/util'
export const getLabel = ({ style = {}, label, required }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    }}
  >
    {required && <span style={{ color: 'red', marginRight: '4px' }}>*</span>}
    <Label style={{ ...style }}>{label} :</Label>
  </div>
)

const title = 'Solar Plant Extra Info'

const PIRow10MinData = ({ targetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [fieldSelectionData, setFieldSelectionData] = useState([])
  const [fieldSelected, setFieldSelected] = useState()
  const [plantSelectionData, setPlantSelectionData] = useState([])
  const [inverterGroupSelectionData, setInverterGroupSelectionData] = useState(
    []
  )
  const [storageGroupSelectionData, setStorageGroupSelectionData] = useState([])
  const { setError } = useContext(ErrorContext)
  // const writePermision = hasAccesPermits({
  //   authGodMode: envConfig.authGodMode,
  //   actionPermits,
  //   eventActions: [ScreenPermissions.SOLAR_PI_ROW_DATA_WRITE],
  //   matchAny: true,
  // })

  useEffect(
    _ => {
      // make sort fieldTitle
      getSolarField(targetInfo).fork(setError, data => {
        const sd = R.sortBy(R.prop('fieldTitle'), data)
        setFieldSelectionData(sd)
        if (!fieldSelected && sd[0] && sd[0].fieldName)
          setFieldSelected(sd[0].fieldName)
      })
    },
    [targetInfo, setError, fieldSelected]
  )

  useEffect(
    _ => {
      getSolarPlant(targetInfo).fork(setError, data => {
        const sd = R.sortBy(R.prop('plantId'), data)
        setPlantSelectionData(sd)
      })
      getSolarInverterGroup(targetInfo).fork(setError, data => {
        const sd = R.sortBy(R.prop('inverterGroupName'), data)
        setInverterGroupSelectionData(sd)
      })
      getSolarStorageGroup(targetInfo).fork(setError, data => {
        const sd = R.sortBy(R.prop('storageGroupName'), data)
        setStorageGroupSelectionData(sd)
      })
    },
    [targetInfo, setError]
  )

  const toSourceNameMap = R.compose(
    R.fromPairs,
    R.map(u => [u.plantId, u.plantName || u.plantId])
  )

  const plantNameMap = toSourceNameMap(plantSelectionData)
  const headerWithFormatter = FieldDataHeaders.map(header =>
    header.ident === 'plantId'
      ? {
          ...header,
          dataFormatter: ({ value }) =>
            value
              ? `${value}${
                  plantNameMap[value] ? `-${plantNameMap[value]}` : ''
                }`
              : value,
        }
      : header
  )
  const screenCriteria = (s, p, u, onChange) => {
    return (
      <>
        <Select
          showSearch
          value={fieldSelected}
          style={{ width: '500px', marginLeft: '10px' }}
          onChange={fieldName => {
            setFieldSelected(fieldName)
            onChange()
          }}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {fieldSelectionData.map(({ fieldName, fieldTitle }) => (
            <Select.Option key={fieldName} value={fieldName}>
              {fieldTitle ?? fieldName}
            </Select.Option>
          ))}
        </Select>
      </>
    )
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    const fieldCurrData = fieldSelectionData.find(
      v => v.fieldName === insertData.fieldName
    )
    const defaultEffectiveDate = moment('01/01/2024', 'DD/MM/YYYY').format(
      DATE_FORMAT_API
    )
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '140px 120px 140px 140px 140px 140px 140px 140px 140px 140px',
          gap: 10,
        }}
      >
        {getLabel({
          label: 'Property Name',
          required: true,
        })}
        <Select
          showSearch
          value={insertData.fieldName}
          style={{ gridColumnEnd: 'span 3' }}
          onChange={val =>
            setInsertData({
              ...insertData,
              fieldName: val,
              subgroupId: '',
              storagegroupId: '',
              plantId: '',
              fieldValue: '',
              effectiveDate: '',
            })
          }
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {fieldSelectionData.map(({ fieldName, fieldTitle }) => (
            <Select.Option key={fieldName} value={fieldName}>
              {fieldTitle ?? fieldName}
            </Select.Option>
          ))}
        </Select>
        {getLabel({ label: 'Plant', required: true })}
        <Select
          showSearch
          value={insertData.plantId}
          style={{ gridColumnEnd: 'span 2' }}
          onChange={val =>
            setInsertData({
              ...insertData,
              plantId: val,
              ...(fieldCurrData &&
                (fieldCurrData.fieldLevel === 'PLANT'
                  ? { subgroupId: 'ALL', storagegroupId: 'ALL' }
                  : fieldCurrData.fieldLevel === 'INVERTER_GROUP'
                  ? { storagegroupId: 'ALL', subgroupId: '' }
                  : fieldCurrData.fieldLevel === 'STORAGE_GROUP'
                  ? { subgroupId: 'ALL', storagegroupId: '' }
                  : {})),
              ...(fieldCurrData?.fieldDateBased !== 'Y' && {
                effectiveDate: defaultEffectiveDate,
              }),
            })
          }
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {fieldCurrData &&
            (fieldCurrData.fieldLevel === 'PLANT'
              ? plantSelectionData
              : fieldCurrData.fieldLevel === 'INVERTER_GROUP'
              ? getValidPlantList(
                  plantSelectionData,
                  inverterGroupSelectionData,
                  []
                )
              : fieldCurrData.fieldLevel === 'STORAGE_GROUP'
              ? getValidStoragePlantList(
                  plantSelectionData,
                  inverterGroupSelectionData,
                  storageGroupSelectionData
                )
              : []
            ).map(({ plantId, plantName }) => (
              <Select.Option key={plantId} value={plantId}>
                {plantName}
              </Select.Option>
            ))}
        </Select>
        {(!fieldCurrData || fieldCurrData?.fieldLevel === 'INVERTER_GROUP') && (
          <>
            {getLabel({
              label: 'Inverter Group',
              required: true,
            })}
            <Select
              showSearch
              value={insertData.subgroupId}
              style={{ gridColumnEnd: 'span 2' }}
              onChange={val =>
                setInsertData({
                  ...insertData,
                  subgroupId: val,
                })
              }
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {inverterGroupSelectionData
                .filter(({ plantId }) => plantId === insertData.plantId)
                .map(({ inverterGroupId, inverterGroupName }) => (
                  <Select.Option key={inverterGroupId} value={inverterGroupId}>
                    {inverterGroupName}
                  </Select.Option>
                ))}
            </Select>
          </>
        )}
        {(!fieldCurrData || fieldCurrData?.fieldLevel === 'STORAGE_GROUP') && (
          <>
            {getLabel({ label: 'Storage Group', required: true })}
            <Select
              showSearch
              value={insertData.storagegroupId}
              style={{ gridColumnEnd: 'span 2' }}
              onChange={val =>
                setInsertData({
                  ...insertData,
                  storagegroupId: val,
                })
              }
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {storageGroupSelectionData
                .filter(({ plantId }) => plantId === insertData.plantId)
                .map(({ storageGroupId, storageGroupName }) => (
                  <Select.Option key={storageGroupId} value={storageGroupId}>
                    {storageGroupName}
                  </Select.Option>
                ))}
            </Select>
          </>
        )}
        {/* <Label label="Char Value" /> */}

        {(!fieldCurrData || fieldCurrData?.fieldDateBased === 'Y') && (
          <>
            {getLabel({ label: 'Effective Date', required: true })}
            <DatePicker
              style={{ gridColumnEnd: 'span 2' }}
              value={
                insertData.effectiveDate && moment(insertData.effectiveDate)
              }
              placeholder="Select Date"
              onChange={date => {
                setInsertData({
                  ...insertData,
                  effectiveDate: date.format(DATE_FORMAT_API),
                })
              }}
              onOk={date => {
                setInsertData({
                  ...insertData,
                  effectiveDate: date.format(DATE_FORMAT_API),
                })
              }}
            />
          </>
        )}

        {getLabel({ label: 'Field Value' })}
        {fieldCurrData?.fieldType === 'NUMBER' ? (
          <InputNumber
            value={insertData.fieldValue}
            style={{ gridColumnEnd: 'span 2' }}
            onChange={val =>
              setInsertData({
                ...insertData,
                fieldValue: val,
              })
            }
          />
        ) : fieldCurrData?.fieldType === 'DATE' ? (
          <DatePicker
            style={{ gridColumnEnd: 'span 2' }}
            value={insertData.fieldValue && moment(insertData.fieldValue)}
            showTime={{
              format: 'h:mm',
              defaultValue: moment('00:00', 'HH:mm'),
            }}
            format="MM/DD/YYYY HH:mm"
            placeholder="Select DateTime"
            onChange={date => {
              setInsertData({
                ...insertData,
                fieldValue: date.format(
                  fieldCurrData?.fieldFormat ?? DATE_TIME_FORMAT_API
                ),
              })
            }}
            onOk={date => {
              setInsertData({
                ...insertData,
                fieldValue: date.format(
                  fieldCurrData?.fieldFormat ?? DATE_TIME_FORMAT_API
                ),
              })
            }}
          />
        ) : (
          <Input
            value={insertData.fieldValue}
            style={{ gridColumnEnd: 'span 2' }}
            onChange={e =>
              setInsertData({
                ...insertData,
                fieldValue: e.target.value,
              })
            }
          />
        )}
        <div />
        <Button
          type="primary"
          style={{ marginLeft: '20px' }}
          onClick={() => onAdd(true)}
        >
          Add
        </Button>
        <Button
          style={{ marginLeft: '20px' }}
          type="primary"
          onClick={() => onAdd(false)}
        >
          Add & Hide
        </Button>
        <Button style={{ marginLeft: '20px' }} type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  return [
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={upsertFieldValue}
      retrieveTask={getAllFieldValue}
      deleteTask={deleteSolarFieldValue}
      screenCriteria={screenCriteria}
      withCriteria={() => ({
        fieldName: fieldSelected,
      })}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      // heightOffset={250}
      initialSortOptions={FieldDataHeaders}
      autoFixColByKey={false}
      // withoutModify={!writePermision}
      // allowInsert={writePermision}
      // withDelete={writePermision}
    />,
  ]
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(PIRow10MinData)

export const FieldDataHeaders = [
  strCol({
    ident: 'fieldName',
    display: 'Property Name',
    width: 400,
    isFiltered: true,
    isKey: true,
    alignment: 'left',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant',
    isKey: true,
    sortOrder: 'asc',
    width: 250,
  }),
  strCol({
    ident: 'subgroupId',
    display: 'Inverter Group',
    sortOrder: 'asc',
    isKey: true,
    width: 200,
    alignment: 'left',
  }),
  strCol({
    ident: 'storagegroupId',
    display: 'Storage Group',
    sortOrder: 'asc',
    isKey: true,
    width: 200,
    alignment: 'left',
  }),
  strCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    sortOrder: 'asc',
    isKey: true,
    width: 200,
  }),
  strCol({
    ident: 'fieldValue',
    display: 'Field Value',
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
].map(d => ({ ...d, ellipsis: true }))
